module.exports = __webpack_public_path__ + "static/media/Trazado1.a12625ca.svg";